import { FormElement } from "app/containers/types";

export interface ResponseError {
  message: string;
}
export type RequestError = ResponseError;

export type UsersListItemType = {
  id?: number;
  isActive: boolean;
  isLoading?: boolean;
  firstName: string;
  lastName: string | null;
  email: string | null;
  mobileNumber: string | null;
  sex: string | null;
  dateOfBirth: string;
  city: string | null;
  groupName: string | null;
  lastLogin: string | null;
  assignedTreatmentType: string | null;
  noOfActiveBankAssigned: string | null;
  noOfFutureTimeSlots: string | null;
};
export type CityListItemType = {
  id: number;
  name: string;
};
export type OrganizationsListItemType = {
  id: number;
  organizationName: string;
};

export type UserGroupListItemType = {
  id: number;
  userGroupName: string;
};

export type InstructorListItemType = {
  id: number;
  firstName: string;
  lastName: string;
};

export type TreatmentListItemType = {
  id: number;
  treatmentName: string;
  type: string;
  session_count: number;
  session_duration: number;
  maximum_participants: number;
};
export interface NewUserRequest {
  firstName: string;
  lastName: string;
  email: string;
  mobileNumber: string;
  companyName: string;
  designation: any;
  numberOfEmployees: string;
  user_type: string;
  isActive: any;
}

export type NewUserResponse = {
  id: any;
  codeSentAt: any;
  firstName: string;
  lastName: string;
  mobileNumber: string;
  countryCode: any;
  email: string;
  companyName: string;
  designation: string;
  numberOfEmployees: string;
  language: string;
  isActive: true;
  role: any;
  image: any;
  userType: string;
  createdAt: string;
  updatedAt: string;
  fullName: string;
  message?: string;
};
export enum RoleEnum {
  "admin" = 1,
  "user" = 2,
  "patient" = 3,
}

export type UserForm = {
  id: FormElement;
  firstName: FormElement;
  lastName: FormElement;
  email: FormElement;
  dob: FormElement;
  mobileNumber: FormElement;
  createdAt: FormElement;
  updatedAt: FormElement;
  ip: FormElement;
  mac: FormElement;
  user_type: FormElement;
  gender: FormElement;
  cityId: FormElement;
  groupId: FormElement;
  street: FormElement;
  role?: {
    id: RoleEnum;
    name: "User" | "Admin";
  };
};

export type OrganisationState = {
  items: Array<OrganizationsListItemType>;
  meta: {
    totalItems: number;
    itemCount: number;
    itemsPerPage: number;
    totalPages: number;
    currentPage: number;
  };
  links: {
    first: string;
    last: string;
    previous: string;
    next: string;
  };
};

export type QuestionnaireState = {
  id: number;
  name: string;
};

export type UserGroupState = {
  items: Array<UserGroupListItemType>;
  meta: {
    totalItems: number;
    itemCount: number;
    itemsPerPage: number;
    totalPages: number;
    currentPage: number;
  };
  links: {
    first: string;
    last: string;
    previous: string;
    next: string;
  };
};

export type TreatmentState = {
  items: Array<TreatmentListItemType>;
  meta: {
    totalItems: number;
    itemCount: number;
    itemsPerPage: number;
    totalPages: number;
    currentPage: number;
  };
  links: {
    first: string;
    last: string;
    previous: string;
    next: string;
  };
};
export type InstructorState = {
  items: Array<InstructorListItemType>;
  meta: {
    totalItems: number;
    itemCount: number;
    itemsPerPage: number;
    totalPages: number;
    currentPage: number;
  };
  links: {
    first: string;
    last: string;
    previous: string;
    next: string;
  };
};
export type UsersListStateType = {
  query: {
    limit: number;
    page: number;
    organizationId: number;
    q: string;
    orderField: string;
    orderDirection: string;
    userGroupId: number;
    treatmentId: number;
    isActive?: boolean;
  };
  form: {
    user: UserForm;
  };
  list: {
    items: Array<UsersListItemType>;
    meta: {
      totalItems: number;
      itemCount: number;
      itemsPerPage: number;
      totalPages: number;
      currentPage: number;
    };
    links: {
      first: string;
      last: string;
      previous: string;
      next: string;
    };
  };
  city: {
    items: Array<CityListItemType>;
    meta: {
      totalItems: number;
      itemCount: number;
      itemsPerPage: number;
      totalPages: number;
      currentPage: number;
    };
    links: {
      first: string;
      last: string;
      previous: string;
      next: string;
    };
  };
  loading: boolean;
  error: string;
  organization: OrganisationState;
  questionnaire: QuestionnaireState[];
  userGroup: UserGroupState;
  treatment: TreatmentState;
  instructor: InstructorState;
  actualInstructor: InstructorState;
  qualification: any;
  departments: any;
  banks: any;
  patientPermission: any;
};

export const UserState: UsersListStateType = {
  query: {
    limit: 10,
    page: 1,
    q: "",
    orderField: "",
    orderDirection: "",
    organizationId: 0,
    userGroupId: 0,
    treatmentId: 0,
    isActive: true,
  },
  list: {
    items: [],
    meta: {
      totalItems: 0,
      itemCount: 0,
      itemsPerPage: 100,
      totalPages: 1,
      currentPage: 1,
    },
    links: {
      first: "",
      previous: "",
      next: "",
      last: "",
    },
  },
  city: {
    items: [],
    meta: {
      totalItems: 0,
      itemCount: 0,
      itemsPerPage: 100,
      totalPages: 1,
      currentPage: 1,
    },
    links: {
      first: "",
      previous: "",
      next: "",
      last: "",
    },
  },
  loading: false,
  questionnaire: [],
  organization: {
    items: [],
    meta: {
      totalItems: 0,
      itemCount: 0,
      itemsPerPage: 100,
      totalPages: 1,
      currentPage: 1,
    },
    links: {
      first: "",
      previous: "",
      next: "",
      last: "",
    },
  },
  userGroup: {
    items: [],
    meta: {
      totalItems: 0,
      itemCount: 0,
      itemsPerPage: 100,
      totalPages: 1,
      currentPage: 1,
    },
    links: {
      first: "",
      previous: "",
      next: "",
      last: "",
    },
  },
  banks: [],
  departments: {
    items: [],
    meta: {
      totalItems: 0,
      itemCount: 0,
      itemsPerPage: 100,
      totalPages: 1,
      currentPage: 1,
    },
    links: {
      first: "",
      previous: "",
      next: "",
      last: "",
    },
  },
  qualification: {
    items: [],
    meta: {
      totalItems: 0,
      itemCount: 0,
      itemsPerPage: 100,
      totalPages: 1,
      currentPage: 1,
    },
    links: {
      first: "",
      previous: "",
      next: "",
      last: "",
    },
  },
  patientPermission: {
    items: [],
    meta: {
      totalItems: 0,
      itemCount: 0,
      itemsPerPage: 100,
      totalPages: 1,
      currentPage: 1,
    },
    links: {
      first: "",
      previous: "",
      next: "",
      last: "",
    },
  },
  treatment: {
    items: [],
    meta: {
      totalItems: 0,
      itemCount: 0,
      itemsPerPage: 100,
      totalPages: 1,
      currentPage: 1,
    },
    links: {
      first: "",
      previous: "",
      next: "",
      last: "",
    },
  },
  instructor: {
    items: [
      {
        id: 1,
        firstName: "",
        lastName: "",
      },
    ],
    meta: {
      totalItems: 0,
      itemCount: 0,
      itemsPerPage: 100,
      totalPages: 1,
      currentPage: 1,
    },
    links: {
      first: "",
      previous: "",
      next: "",
      last: "",
    },
  },
  actualInstructor: {
    items: [
      {
        id: 1,
        firstName: "",
        lastName: "",
      },
    ],
    meta: {
      totalItems: 0,
      itemCount: 0,
      itemsPerPage: 100,
      totalPages: 1,
      currentPage: 1,
    },
    links: {
      first: "",
      previous: "",
      next: "",
      last: "",
    },
  },
  form: {
    user: {
      id: { value: "" },
      firstName: { value: "" },
      lastName: { value: "" },
      mobileNumber: { value: "" },
      createdAt: { value: "" },
      dob: { value: null },
      email: { value: "" },
      gender: { value: "" },
      updatedAt: { value: "" },
      user_type: { value: "" },
      ip: { value: "" },
      mac: { value: "" },
      cityId: { value: "" },
      street: { value: "" },
      groupId: { value: "" },
    },
  },
  error: "",
};

export type ContainerState = UsersListStateType;
